module.exports = __webpack_public_path__ + "img/sort-desc.28a49ffb.svg";